<script setup lang="ts">
// types
import type { SectionInternalLinkProps } from '@ts-sections/section-internal-link/interfaces'
// hooks
import { useSectionInternalLink } from '@hooks/sections/section-internal-link.hook'
// components
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import BlockInternalLink from '@Blocks/BlockInternalLink.vue'

defineOptions({
  name: 'SectionInternalLink',
})

const props = defineProps<{
  section: SectionInternalLinkProps
}>()

const {
  refBackgroundColor,
} = useSectionInternalLink({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-internal-link"
    :data-component="section.__component"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <BlockInternalLink
      v-if="section.links"
      :block="section.links"
    />
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionInternalLink.scss" />
